import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquized: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"squized,centered,aligned"} maskId="square-filled-radius-0-stroke-1-IconSquized"><path fillRule="evenodd" clipRule="evenodd" d="M12.5 3V21H11.5V3H12.5ZM5.5 8.29289L9.20711 12L5.5 15.7071L4.79289 15L7.29289 12.5H1V11.5H7.29289L4.79289 9L5.5 8.29289ZM19.2071 9L16.7071 11.5H23V12.5H16.7071L19.2071 15L18.5 15.7071L14.7929 12L18.5 8.29289L19.2071 9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquized;
